import script from "./ModalListaGestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalListaGestion.vue?vue&type=script&setup=true&lang=ts"

import "./ModalListaGestion.vue?vue&type=style&index=0&id=afe37b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe37b48"]])

export default __exports__